import { render, staticRenderFns } from "./SecurityMeasures.vue?vue&type=template&id=3b128b90"
import script from "./SecurityMeasures.vue?vue&type=script&lang=js"
export * from "./SecurityMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports